import { ENTITY_REQUEST_FORMS_CRUD_ACTION_CONSTANTS } from '../actions/entity_request_forms_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['entityRequestFormsIndex']);
export default standardReducerGenerator(ENTITY_REQUEST_FORMS_CRUD_ACTION_CONSTANTS, initialState);
